import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { FC, useRef, useState } from 'react';
import { CurrencySymbols, MonetizationTariff, ProductType } from 'types/enums';
import { getCountedItemKey } from 'utils/getCountedItemKey';
import { ShopPages } from '../..';
import AddInfo from './AddInfo';
import styles from './style.module.scss';
import Tariff from './Tariff';

export interface TariffCard {
  tariff: MonetizationTariff;
  totalCount: number;
  isActive: boolean;
  currentCount: number;
  price: number;
  type: ProductType;
  currency: CurrencySymbols;
  expiredIn: string;
  isPartialPayment: boolean;
  id: number;
  setPage: (n: ShopPages) => void;
}

const COUNT_PLACEMENTS_FOR_DISPLAY_WARNING = 1;

const TariffCard: FC<TariffCard> = ({ currentCount, totalCount, expiredIn, setPage, ...props }) => {
  const t = useTranslations();
  const [isShowAddInfo, setIsShowAddInfo] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const isHiddenWarning =
    (currentCount > COUNT_PLACEMENTS_FOR_DISPLAY_WARNING &&
      totalCount > COUNT_PLACEMENTS_FOR_DISPLAY_WARNING) ||
    props.isPartialPayment;

  const doAFlip = () => {
    if (!containerRef) return;

    containerRef.current.classList.toggle(styles.container__isFlipped);
  };

  const handleClickWarning = () => {
    setIsShowAddInfo(true);
    doAFlip();
  };

  return (
    <div className={styles.container} ref={containerRef}>
      <div
        className={classNames(styles.outerTariff, styles.face, {
          [styles.outerTariff__smallWidth]: !isShowAddInfo,
        })}
        key={expiredIn}>
        <Tariff
          {...props}
          isHiddenWarning={isHiddenWarning}
          isShowAddInfo={isShowAddInfo}
          totalCount={totalCount}
          currentCount={currentCount}
          expiredIn={expiredIn}
        />
        <div
          className={classNames(styles.placementsWarning, {
            [styles.placementsWarning__disabled]: isHiddenWarning,
          })}
          onClick={handleClickWarning}>
          <div
            className={
              styles.placementsWarning__title
            }>{`${t('shop_leave')} ${t(getCountedItemKey(props.type), { count: 1 })}`}</div>
          <Image src='/icons/info-orange.svg' width={18} height={18} alt='info orange' />
        </div>
      </div>
      <div className={classNames(styles.outerTariff, styles.face, styles.back)}>
        <AddInfo
          doAFlip={doAFlip}
          setIsShowAddInfo={setIsShowAddInfo}
          setPage={setPage}
          type={props.type}
        />
      </div>
    </div>
  );
};

export default TariffCard;
